import React from "react";
import { useAuth0 } from "../../react-auth0-spa";

const LogoutAll = () => {

    const { isAuthenticated } = useAuth0();

    if (isAuthenticated) {
        //console.log(process.env["REACT_APP_SSO_LOGOUT_ALL_URL"])
       	window.location = process.env["REACT_APP_SSO_LOGOUT_ALL_URL"]
    }

}

export default LogoutAll;